module.exports = __webpack_public_path__ + "static/media/user.bc1cbac9.svg";